import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useContext } from 'react';
import { LoansContext } from '../../contexts/loans-context';

export const MyLoans = (props) => {
  const {loansData} = useContext(LoansContext);
  const clubId = props.clubId;
  const getPlayerName = (playerId) => {
    let playerName = "";
    props.leaderboardData.forEach((club) => {
        club.players.forEach((player) => {
            if(player.playerId === playerId) {
                playerName = player.lastName;
                return;
            }
        });
    });

    props.auctionListData.forEach((player) => {
        if(player.playerId === playerId) {
            playerName = player.lastName;
            return;
        }
    });
    return playerName;
  }

  return (
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 350 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell >In</TableCell>
            <TableCell >Out</TableCell>
            <TableCell >Week</TableCell>
            <TableCell >Window</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loansData.allLoans.map((row) => (
            row.clubid === props.clubId && (
              <TableRow key={row.playerin}>
                <TableCell >{getPlayerName(row.playerin)}</TableCell>
                <TableCell >{getPlayerName(row.playerout)}</TableCell>
                <TableCell >{row.startweek}</TableCell>
                <TableCell >{row.windowid}</TableCell>
              </TableRow>
            )
          ))}
        </TableBody>
      </Table>      
    </TableContainer>
  );
};
